import PropTypes from "prop-types";
import React, { useCallback, useMemo } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { TextFieldCompo } from "../../../components/Comman/TextFieldCompo";
import TypographyCompo from "../../../components/Comman/TypographyCompo";

const BillingPreviewProductDetailRow = ({
	rowIndex,
	billHeaderId,
	billDetails,
	isShowBillDiscountAndCD,
	showDiscountAmtEditable,
	onItemDiscPerChange,
	onItemDiscAmtChange,
}) => {
	const handleItemDiscPerChange = useCallback(
		(event) => {
			onItemDiscPerChange(billHeaderId, billDetails.id, event);
		},
		[onItemDiscPerChange, billHeaderId, billDetails.id],
	);

	const handleItemDiscAmtChange = useCallback(
		(event) => {
			onItemDiscAmtChange(billHeaderId, billDetails.id, event);
		},
		[onItemDiscAmtChange, billHeaderId, billDetails.id],
	);

	const discAmtErrorText = useMemo(() => {
		if (
			parseFloat(billDetails.itemDiscAmt) >
			billDetails.rate * billDetails.qty
		) {
			return "Discount amount exceeds total amount";
		}
		return "";
	}, [billDetails.itemDiscAmt, billDetails.rate, billDetails.qty]);

	const taxPercent = (
		billDetails.cgstPer + billDetails.sgstPer + billDetails.igstPer
	).toFixed(2);
	const taxAmount = (
		billDetails.cgstAmt + billDetails.sgstAmt + billDetails.igstAmt
	).toFixed(2);

	return (
		<TableRow>
			<TableCell align="center">
				<TypographyCompo>{rowIndex + 1}</TypographyCompo>
			</TableCell>
			<TableCell align="left">
				<TypographyCompo className="cell-product">
					{billDetails?.product?.name || ""}
				</TypographyCompo>
			</TableCell>
			<TableCell align="right">
				<TypographyCompo>
					{billDetails !== null ? billDetails.qty.toFixed(2) : ""}
				</TypographyCompo>
			</TableCell>
			<TableCell align="right">
				<TypographyCompo>
					{billDetails !== null ? taxPercent : ""}
				</TypographyCompo>
			</TableCell>
			<TableCell align="right">
				<TypographyCompo>
					{billDetails !== null ? taxAmount : ""}
				</TypographyCompo>
			</TableCell>
			{isShowBillDiscountAndCD ? (
				<TableCell align="center">
					<TextFieldCompo
						placeHolder={"Discount %"}
						size="small"
						color="primary"
						name="itemDiscPer"
						value={billDetails.itemDiscPer}
						onChange={handleItemDiscPerChange}
						fullWidth={false}
						errorText={""}
					/>
				</TableCell>
			) : (
				<TableCell align="center">
					<TypographyCompo>
						{billDetails !== null ? billDetails.itemDiscPer : ""}
					</TypographyCompo>
				</TableCell>
			)}
			{showDiscountAmtEditable ? (
				<TableCell align="center">
					<TextFieldCompo
						placeHolder={"Discount Amount"}
						size="small"
						color="primary"
						name="itemDiscAmt"
						id={String(billDetails.id)}
						value={billDetails.itemDiscAmt}
						onChange={handleItemDiscAmtChange}
						fullWidth={false}
						errorText={discAmtErrorText}
					/>
				</TableCell>
			) : (
				<TableCell align="center">
					<TypographyCompo>
						{billDetails !== null
							? parseFloat(billDetails.itemDiscAmt || 0).toFixed(2)
							: ""}
					</TypographyCompo>
				</TableCell>
			)}
			<TableCell align="right">
				<TypographyCompo>
					{billDetails !== null ? billDetails.taxableAmt.toFixed(2) : ""}
				</TypographyCompo>
			</TableCell>
			<TableCell align="right">
				<TypographyCompo className="cell-total">
					{billDetails !== null ? billDetails.totalAmt.toFixed(2) : ""}
				</TypographyCompo>
			</TableCell>
		</TableRow>
	);
};

BillingPreviewProductDetailRow.propTypes = {
	rowIndex: PropTypes.number.isRequired,
	billHeaderId: PropTypes.string.isRequired,
	billDetails: PropTypes.object.isRequired,
	isShowBillDiscountAndCD: PropTypes.bool.isRequired,
	showDiscountAmtEditable: PropTypes.bool.isRequired,
	onItemDiscPerChange: PropTypes.func.isRequired,
	onItemDiscAmtChange: PropTypes.func.isRequired,
};

export default React.memo(BillingPreviewProductDetailRow);
